"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagAS = function FlagAS(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,139.3v-7.8L-147.63,12.18,216.6-107.14v-7.8a7,7,0,0,0-3.46-5.93L-193,12.18l406.14,133a7,7,0,0,0,3.46-5.93Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-147.63,12.18,216.6,131.5V-107.14Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M173.48-22.57s24.18,1,26.44-.82,2.66-14.15-5.33-16-29.72,10-29.72,10Zm0,0",
    transform: "translate(194 123)",
    fill: "#fff5dc"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M126.14-3.52a15.22,15.22,0,0,0-.41,3.69c-.14,3,.41,10.79,9.84,14.21l-2.19,9.16,10,6s7.38-10.93,7.79-20.09-25-13-25-13Zm0,0",
    transform: "translate(194 123)",
    fill: "#d27d69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M96.22-9.66l3.89-3.9s-8,4.86-11,.48c-4-5.74,1.37-11.75,6.91-14.42s16.59-.61,16.59-.61l7,17.83L98.47,3Zm0,0",
    transform: "translate(194 123)",
    fill: "#d27d69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M161.59-43.68l18.86-2.26A51.27,51.27,0,0,1,164.05-32s11.28,0,14.55,3.89-3.27,7.58-5.73,8.81S149.09-4.95,149.09-4.95L130-7.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#d27d69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M175.6-58.17s4.1-9.56,4-16.26l-13.8,9.57s3.14-1.5,2.05-7L122.73-47.37l-9.16,16.26,27.87,8.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#d27d69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M141.61,16.36l-4.71,7.48s-8.4-1.84-11.27.21-3.18,9.74,1.84,10.35c0,0,3.49,2.15,5.53.41,0,0,4.21,1.64,4.92-1a8.41,8.41,0,0,0-.2-4.92h3l5.22-9.32Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M99.5.17s13.11-6.56,13.11-16.39-12.16-10.39-22-7.11c0,0-5.88-4.64-1-9.29C96.4-39,125.73-52.29,125.73-52.29L122.45-35.9s11.68,6.15,16.4,3.28c4-2.41,42.62-32.79,42.62-32.79S178.19-49,155.24-32.62l-2.43,12.16a8.82,8.82,0,0,1-4.71,6.17l-9.25,4.63s26.23,3.27,26.23,6.55-6.56,19.68-19.67,26.23l-6.56-6.55,3.27-9.84A154.65,154.65,0,0,1,125.73.17s-9.84,3.28-16.39,3.28S99.5.17,99.5.17Zm0,0",
    transform: "translate(194 123)",
    fill: "#b95546"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M79.82,16.57V9.75A7.31,7.31,0,0,1,82,4.59L96.22-9.66,99.5-3.11h13.12L109.34.17V3.45l-16.4,9.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#fff5dc"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M86.38,13.29H79.82s-6.55,9.83,0,9.83c0,0,9.84-6.55,13.12-9.83,0,0,0-3.28-6.56,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M166.37,27.84H121a2,2,0,0,0-1.49-.67s-7.94-3.29-9.07-3.29h-.93a2.05,2.05,0,0,0-2,2.05v1.91H97.14V25.93a2,2,0,0,0-2-2.05h-.93a2.05,2.05,0,0,0-2,2.05v0c-4.44-.18-13.93-.75-18.85-2.39L47,30.13l26.23,6.56c4.91-1.64,14.41-2.21,18.85-2.39v0a2.05,2.05,0,0,0,2,2h.93a2,2,0,0,0,2-2V32.43H107.5v1.91a2.05,2.05,0,0,0,2,2h.93c1.13,0,9.07-3.29,9.07-3.29a2,2,0,0,0,1.49-.66h45.33a2.3,2.3,0,0,0,0-4.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M164.4,36.65c-2.74-.54-34,4.92-34,4.92s-1.91-1.91,3.83-7.24l-2.73-.69s-6,4.24-8.47,4.79c-2.12.47-6.85,2.77-7.87,5.84l-19,3.18.41,1.64,18.69-2.2a4.29,4.29,0,0,0,5.91,2.6,5.54,5.54,0,0,0,5.19-.82s4.92.82,5.19-3.69l34.29-5.19s1.37-2.59-1.36-3.14Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M145,59.74s-2.6,3.42-9,.41-13.94.28-18-.68-10.24-3.42-16-1.23-8.88,2-7.65-.69,1.91-4.78,0-5.73l2.18-2.73-.41-1.64s-10.93-4.24-18.3,1.64-5.19,19.26,7.1,20.21c0,0,3.83,4.79,13.25,3.42,0,0,6.15,4.24,16.67,2.32,0,0,.41,1.23,7.24.69s14.49.27,13.12,4.91c0,0,5.05-1,2.05-5.6,0,0,6-.27,10.11,3.28A7,7,0,0,0,143.63,72s6.69-2.33,10.39,0a8.86,8.86,0,0,0-9-4.51s4.78-3.83,7-2.87c0,0-2.05-2.46-8.06,0,0,0,3.83-2.32,1.1-4.92Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagAS;
exports["default"] = _default;